import styled from "styled-components";

export const GhostBtn = styled.button`
  cursor: pointer;
  background-color: transparent;
  padding: 0;
  outline: 0;
  border: none;
`;
